const zhCommon = {
  'site.name': '91在线吃瓜网',
  'site.slogan': '每日猛料不停更',
  'site.description': '聚焦网红明星塌房现场、聊天记录泄露、反差视频',
  'nav.home': '首页',
  'nav.categories': '分类',
  'nav.about': '关于我们',
  'nav.starScandal': '明星丑闻',
  'nav.influencer': '网红塌房',
  'nav.leakedChats': '泄露聊天',
  'nav.contrastVideo': '反差视频',
  'breadcrumb.home': '首页',
  'btn.watchNow': '立即开瓜',
  'btn.downloadApp': '下载吃瓜APP',
  'btn.viewMore': '查看更多',
  'btn.backHome': '返回首页',
  'btn.lineOne': '线路一入口',
  'btn.subscribe': '订阅更新',
  'btn.contact': '联系我们',
  'btn.submit': '提交',
  'footer.brand': '在线吃瓜',
  'footer.rights': '© 2026 91在线吃瓜网 版权所有',
  'footer.disclaimer': '本站内容来源于网络公开信息，仅供娱乐参考，如有不实请联系我们删除。',
  'tag.hot': '热门',
  'tag.top': '置顶',
  'tag.exclusive': '独家黑料',
  'tag.hotToday': '今日TOP1爆料',
  'label.views': '次围观',
  'label.comments': '条评论',
  'label.publishedAt': '发布于',
  'label.verified': '已验证',
  'label.insider': '知情人士',
  'label.recommended': '猜你喜欢',
  'label.related': '相关推荐',
  'label.channelNav': '频道导航',
  'form.email': '输入您的邮箱',
  'form.emailPlaceholder': 'hello@hnqxp01.cn',
  'msg.subscribeSuccess': '订阅成功！我们会第一时间通知您最新爆料。',
  'msg.copySuccess': '链接已复制到剪贴板',
};

export default zhCommon;